import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import SchoolProfile from './profile/js/schoolProfile';
import SchoolTable from './table/js/schoolTable';
import SchoolCreate from './create/js/schoolCreate';
import PropTypes from 'prop-types';

function SchoolManagement({ initialTab = 'schools' }) {
  const [activeTab] = useState(initialTab);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const renderContent = () => {
    switch (activeTab) {
      case 'profile':
        return <SchoolProfile />;
      case 'schools':
      default:
        return <SchoolTable reloadKey={reloadKey} onCreateSchool={() => setShowCreateModal(true)} />;
    }
  };

  return (
    <div className="eduss-school-management" style={{ padding: '20px' }}>
      <div className="eduss-school-management-content">{renderContent()}</div>

      {/* Create School Modal */}
      {showCreateModal && createPortal(
        <div className="eduss-global-modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="eduss-global-modal large eduss-admin-form-modal" onClick={e => e.stopPropagation()}>
            <div className="eduss-global-modal-header">
              <h3>Create New School</h3>
              <button onClick={() => setShowCreateModal(false)}>&times;</button>
            </div>
            <div className="eduss-global-modal-content">
              <SchoolCreate
                onClose={() => setShowCreateModal(false)}
                onSubmit={() => { setReloadKey(k => k + 1); setShowCreateModal(false); }}
              />
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}

SchoolManagement.propTypes = {
  initialTab: PropTypes.string,
};

export default SchoolManagement;
